import PostCommentCompose from './PostCommentCompose'

export default PostCommentCompose
